module.exports = __webpack_public_path__ + "Ubuntu-Regular.84ea7c5c9d2fa40c070c.ttf";


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/assets/fonts/Ubuntu/Ubuntu-Regular.ttf
// module id = ../../../../../src/assets/fonts/Ubuntu/Ubuntu-Regular.ttf
// module chunks = styles